import cuid from 'cuid';
import { ANONYMOUS_USER_ID_LOCAL_STORAGE_KEY } from '../constants';

export function anonymousId() {
	const id = localStorage.getItem(ANONYMOUS_USER_ID_LOCAL_STORAGE_KEY);

	if (id) {
		return id;
	}

	const newId = window.analytics?.user?.().anonymousId?.() ?? cuid();
	localStorage.setItem(ANONYMOUS_USER_ID_LOCAL_STORAGE_KEY, newId);

	return newId;
}
